import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './user.reducer';

export const selectUserState = createFeatureSelector<UserState>('user');

export const selectUserProfile = createSelector(selectUserState, (state) => state.profile);
export const selectUserStatus = createSelector(selectUserState, (state) => state.status);
export const selectUserError = createSelector(selectUserState, (state) => state.error);
export const selectDisplayName = createSelector(
  selectUserProfile,
  (profile) => profile?.fullName || 'Unknown',
);
export const selectDesignation = createSelector(
  selectUserProfile,
  (profile) => profile?.designation || '—',
);
export const selectPrivilegeNames = createSelector(
  selectUserProfile,
  (profile) => profile?.privileges ?? [],
);
export const selectRoleNames = createSelector(
  selectUserProfile,
  (profile) => profile?.applications ?? [],
);

export const selectHasPrivilege = (name: string) =>
  createSelector(selectPrivilegeNames, (privileges) => privileges.includes(name));

export const selectHasAnyAccess = (roles: string[], privileges: string[]) =>
  createSelector(selectRoleNames, selectPrivilegeNames, (actualRoles, actualPrivileges) => {
    const normalizedRoles = actualRoles.map((role) => role.toLowerCase());
    return (
      roles.some((role) => normalizedRoles.includes(role.toLowerCase())) ||
      privileges.some((privilege) => actualPrivileges.includes(privilege))
    );
  });
